import { appApi } from "@/services/api";

export type RegisterCityContextChangedParams = {
	uf?: string;
	ibgeCode?: string;
	cnes?: string;
};

export async function registerCityContextChanged({
	uf,
	ibgeCode,
	...params
}: RegisterCityContextChangedParams) {
	await appApi.post(
		`${uf ? `/uf/${uf}` : ""}${
			uf && ibgeCode ? `/city/${ibgeCode}` : ""
		}/userauditlog/register-city-context-changed`,
		undefined,
		{
			params,
		}
	);
}
